import DashboardIcon from "@mui/icons-material/Dashboard";
import GoalIcon from "@mui/icons-material/Star";
import EvaluationIcon from "@mui/icons-material/Assessment";
import FeedbackIcon from "@mui/icons-material/Feedback";
import TeamIcon from "@mui/icons-material/Group";
import ReviewsIcon from "@mui/icons-material/RateReview";
import SupportIcon from "@mui/icons-material/Help";
import SettingsIcon from "@mui/icons-material/Settings";
import { specialNames } from "constants/specialNames";

interface INavLink {
  text: string;
  icon: JSX.Element;
  route: string;
  roles: string[];
}

export const navLinksMenu: INavLink[] = [
  { text: "Dashboard", icon: <DashboardIcon />, route: "/", roles:[specialNames.MANAGER,specialNames.EMPLOYEE,specialNames.ADMIN] },
  { text: "Goals", icon: <GoalIcon />, route: "/goals",roles:[specialNames.MANAGER,specialNames.EMPLOYEE,specialNames.ADMIN] },
  {
    text: "Evaluation",
    icon: <EvaluationIcon />,
    route: "/evaluation",
    roles: [specialNames.MANAGER,specialNames.ADMIN],
  },
  { text: "Feedback", icon: <FeedbackIcon />, route: "/feedback",roles:[specialNames.MANAGER,specialNames.EMPLOYEE,specialNames.ADMIN] },
  { text: "Team", icon: <TeamIcon />, route: "/team", roles: [specialNames.MANAGER,specialNames.ADMIN] },
  { text: "Reviews", icon: <ReviewsIcon />, route: "/reviews",roles:[specialNames.MANAGER,specialNames.EMPLOYEE,specialNames.ADMIN] },
];

export const navLinksSettings: INavLink[] = [
  { text: "Support", icon: <SupportIcon />, route: "/support",roles:[specialNames.MANAGER,specialNames.EMPLOYEE,specialNames.ADMIN] },
  { text: "Settings", icon: <SettingsIcon />, route: "/settings",roles:[specialNames.MANAGER,specialNames.EMPLOYEE,specialNames.ADMIN] },
];
